import {
  SECTION_EMPLOYEE_MANAGEMENT,
  SECTION_WORKFORCE_SETTINGS,
} from "common/routes/sections/main.sections";

export const WORKFORCE_SETTINGS_URL = `/${SECTION_WORKFORCE_SETTINGS.path}`;
export const EMPLOYEE_MANAGEMENT_URL = `/${SECTION_EMPLOYEE_MANAGEMENT.path}`;

export const WORKFORCE_DATA_PREVIEW = {
  path: "data-preview/",
  backTo: null,
  subtitle: "Import Data Preview",
  title: "Import Data Preview",
  withStepper: false,
  withDate: false,
};

export const WORKFORCE_TEMPLATE_SETUP = {
  path: "template-setup/",
  backTo: null,
  subtitle: "Import Template Setup",
  title: "Import Template Setup",
  withStepper: false,
  withDate: false,
};

export const EMPLOYEE_MANAGEMENT_PATH = `/${SECTION_EMPLOYEE_MANAGEMENT.path}`;
export const DATA_PREVIEW_PATH = `/${SECTION_EMPLOYEE_MANAGEMENT.path}${WORKFORCE_DATA_PREVIEW.path}`;
export const TEMPLATE_SETUP_PATH = `/${SECTION_EMPLOYEE_MANAGEMENT.path}${WORKFORCE_TEMPLATE_SETUP.path}`;
